<template>
	<b-tab :title="getMessage(data.name)">
		<div class="input-group mt-3 align-items-stretch">
			<input type="text" :placeholder="$t('Find Transaction Number')" class="form-control no-border" v-model="search" v-on:keyup.enter="doSearch">
			<button class="input-group-append search-icon" @click="doSearch">
				<img :src="`${publicPath}/img/rcp/icon/search.png`">
			</button>
		</div>

	    <div class="card-management">
			<TransactionTable v-if="items.length>0" :items="items" :fields="fields" :labelEach="1"></TransactionTable>
			<div v-else class="text-center p-5">{{ $t('No history records available') }}</div>
		</div>
		<b-pagination
	      v-model="currentPage"
	      :total-rows="totalCount"
	      :per-page="perPage"
	      aria-controls="data.name"
	      v-on:input="onChange"
	    ></b-pagination>
	</b-tab>
</template>

<script>
	
	import Vue from 'vue'
	import Topup from "@/services/Topup";
	import Global from "@/services/Global";
	import TransactionTable from '@/components/TransactionTable';

	export default {
	    data() {
	      return {
			publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
	      	items : [],
			fields : ["trx_hash","transaction_number","card_number","card_currency","amount","deposit_fee","card_fee","status","date"],
	      	currentPage : 1,
	      	perPage : 10,
	      	totalCount : 0,
			search : '',
	      	months  : ['January','February','March','April','May','June','July','August','September','October','November','December']
	      }
	  	},
	  	props: ['data','list', 'type'],
	    components: {
			TransactionTable
	    },
	    methods: {
			getMessage: function (key) {
				return this.$t(key)
			},
			doSearch(){
				this.getList();	
			},
	    	setPaging(response){
              	this.totalCount = response.data.page.totalCount;
              	this.perPage = response.data.page.perPage;
              	this.currentPage = response.data.page.currentPage;
		    },
		    init(data){
		    	this.items = [];

				for (var i = 0; i < data.length; i++) {


					var status = "";
					
					for (var j = 0; j < this.list.length; j++) {
						if(this.list[j].id!=1 && this.list[j].id!=6){
							if(typeof this.list[j].enum == "string"){
								const arrEnum = JSON.parse(this.list[j].enum);
								if(arrEnum.includes(data[i].status)){
									status = this.list[j].name;
									break;
								}
							}
							else if(parseInt(this.list[j].enum) == data[i].status){
								status = this.list[j].name;
								break;
							}

						}
					}

					const request_amount = parseFloat(data[i].amount);
					const fee = (request_amount*parseFloat(data[i].fee?data[i].fee:0)/100);
					
					const amount_for_topup = parseFloat(data[i].amount_for_topup?data[i].amount_for_topup:(data[i].amount_topup?data[i].amount_topup:0));
					const deposit_fee = parseFloat(data[i].amount_fee?data[i].amount_fee:0);
					const card_fee = parseFloat(data[i].amount_card?data[i].amount_card:0);

					this.items.push({
						"trx_hash":data[i].trx_hash,
						"transaction_number":data[i].trans_no,
						"card_number":data[i].card_number,
						"card_currency":data[i].currency,
						"amount":"USDT "+Global.addCommas(parseFloat(data[i].amount))+"<br>("+data[i].currency+" "+Global.addCommas(amount_for_topup)+")",
						"deposit_fee":Global.addCommas(deposit_fee),
						"card_fee":	Global.addCommas(card_fee),
						"status":status,
						"rejected_code":data[i].rejected_code,
						"date":data[i].updated_at?data[i].updated_at:data[i].created_at
					});
				}
		    },
	    	getList(){

		    	var opt = {
		    		sort 				: "-id",
		    		page  				: this.currentPage,
		    		pagesize 			: this.perPage,
		    		"search[status]"	: this.data.enum,
					"search[trans_no]"	: this.search,
					sort				: "-updated_at",
		    		expand 				: "topupfile"
		    	};

		    	Topup.list(opt).then(response => {
	    			if(response.status == 200){
	    				this.init(response.data.data);
	              		this.setPaging(response);
	              	}
	            })
	            .catch(err => {
	              this.checkError(err);
	            });

		    },
		    onChange(){
		    	this.getList();	
		    },
	    	checkError(err){
		        const response = err.response;        
		        if(response.status == 401 && response.data.name == "Unauthorized"){
		                localStorage.removeItem("token");
		                localStorage.removeItem("member");
		                localStorage.removeItem("isFirstTime");
		                this.$router.push({ 
		                  path: '/login', 
		                });
		              }
		        else{
		          var msg = (err.response.data)?err.response.data.message:err.message;
		          
		          this.$notify({
					type: 'warn',
					text: msg
					})
		        }
		    }
	    },
	    mounted(){
	    	this.getList();
	    }
  	}
</script>